import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  useDisclosure,
  InputGroup,
  InputRightElement,
  Badge,
  Progress,
  SimpleGrid,
  Skeleton,
} from "@chakra-ui/react";
import React, { memo, useState, useMemo } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import IconCheck from "../../../assets/images/booking/check-circle.svg";
import IconRed from "../../../assets/images/booking/x-red.svg";
import calendarIcon from "../../../assets/images/onleave/calendar.svg";
import DatePicker from "react-datepicker";
import { useBrokerDebtCertificateInLocking } from "../../../hooks/useBrokerDebtCertificateInLocking";
import BrokerDebtCertificateInLockingTable from "../brokerDebtCertificateInLockingTable";

const FormInfo = memo(({ isOpen, onClose, defaultValues }) => {
  const [zIndex, setZIndex] = useState(1);
  const chartParams = useMemo(() => {
    const p = {};
    if (defaultValues?.employeeId) p.employeeId = defaultValues.employeeId;
    return p;
  }, [defaultValues]);

  const {
    BrokerDebtCertificateInLockingListData,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
    refetch,
  } = useBrokerDebtCertificateInLocking(chartParams);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"60%"}
      >
        <Box
          paddingBottom={"80px"}
          h={"86.5vh"}
          w={"100%"}
          overflowY={"auto"}
          sx={{
            "&::-webkit-scrollbar": { width: "4px" },
            "&::-webkit-scrollbar-thumb": {
              width: "4px",
              borderRadius: "50px",
              background: "var(--color-background)",
            },
          }}
        >
          {/* Header */}
          <Flex
            alignItems={"center"}
            p={"25px 24px 16px 24px"}
            position={"relative"}
            borderBottom={"1px solid var(--border-input-employee)"}
          >
            <Box>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"700"}
              >
                Chi tiết chứng chỉ môi giới
              </Text>

              {/* Employee + Range */}
              <Text fontSize="12px" color="#51607B" mt="4px">
                {defaultValues?.nameEmployee || ""}{" "}
                {defaultValues?.codeEmployee
                  ? `(${defaultValues?.codeEmployee})`
                  : ""}
              </Text>
            </Box>

            <Box
              position={"absolute"}
              top={"18px"}
              right={"18px"}
              cursor={"pointer"}
              onClick={onClose}
            >
              <Image src={IconX} />
            </Box>
          </Flex>

          {/* Danh sách */}
          <Box p={"24px"}>
            <BrokerDebtCertificateInLockingTable
              BrokerDebtCertificateInLockingListData={
                BrokerDebtCertificateInLockingListData
              }
              isLoading={isLoading}
              isRefetching={isRefetching}
              totalPages={totalPages}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              entries={entries}
              startEntry={startEntry}
              endEntry={endEntry}
              refetch={refetch}
            />
          </Box>

          <Box
            position={"absolute"}
            w={"100%"}
            bottom={"0"}
            bg={"var(--color-main)"}
            borderTop={"0.5px solid var(--bg-line-employee)"}
            borderRadius={"0px 0px 16px 16px"}
            h="12px"
          />
        </Box>
      </ModalContent>
    </Modal>
  );
});

export default FormInfo;